import { OutboundCampaign } from '@/types/TOutbound';
import apiClient from '@/utils/apiClient';

const OUTBOUND_URL = '/api/outbound/task';
const WORKFLOW_URL = '/api/outbound/workflow';

export interface CreateTaskResponse {
	message: string;
	task: OutboundCampaign;
}

export const createOutboundTask = async (
	taskData: any,
	isNoviUser: boolean = false,
): Promise<CreateTaskResponse> => {
	const response = await apiClient.request({
		method: 'POST',
		endPoint: OUTBOUND_URL,
		body: taskData,
		clientType: isNoviUser ? 'NOVI' : 'RECEPTIONIST',
	});
	return response;
};

export const getOutboundTasks = async (
	isNoviUser: boolean = false,
): Promise<{ message: string; tasks: OutboundCampaign[] }> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: OUTBOUND_URL,
		clientType: isNoviUser ? 'NOVI' : 'RECEPTIONIST',
	});
	return response;
};

export const updateOutboundTask = async (
	taskId: string,
	taskData: any,
	isNoviUser: boolean = false,
): Promise<CreateTaskResponse> => {
	const response = await apiClient.request({
		method: 'PATCH',
		endPoint: `${OUTBOUND_URL}/${taskId}`,
		body: taskData,
		clientType: isNoviUser ? 'NOVI' : 'RECEPTIONIST',
	});
	return response;
};

export const updateOutboundTaskStatus = async (
	taskId: string,
	status: 'Active' | 'Paused' | 'Draft',
	isNoviUser: boolean = false,
): Promise<CreateTaskResponse> => {
	const response = await apiClient.request({
		method: 'PATCH',
		endPoint: `${OUTBOUND_URL}/${taskId}/status`,
		body: { status },
		clientType: isNoviUser ? 'NOVI' : 'RECEPTIONIST',
	});
	return response;
};

export const deleteOutboundTask = async (
	taskId: string,
	isNoviUser: boolean = false,
): Promise<{ message: string }> => {
	const response = await apiClient.request({
		method: 'DELETE',
		endPoint: `${OUTBOUND_URL}/${taskId}`,
		clientType: isNoviUser ? 'NOVI' : 'RECEPTIONIST',
	});
	return response;
};

export const getWorkflows = async (
	clientId: string,
	isNoviUser: boolean = false,
): Promise<{ message: string; workflows: any[] }> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: `${WORKFLOW_URL}/${clientId}`,
		clientType: isNoviUser ? 'NOVI' : 'RECEPTIONIST',
	});
	return response;
};

export const createWorkflow = async (
	clientId: string,
	workflowData: any,
	isNoviUser: boolean = false,
): Promise<{ message: string; workflow: any }> => {
	const response = await apiClient.request({
		method: 'POST',
		endPoint: `${WORKFLOW_URL}/${clientId}`,
		body: workflowData,
		clientType: isNoviUser ? 'NOVI' : 'RECEPTIONIST',
	});
	return response;
};

export const updateWorkflow = async (
	clientId: string,
	workflowId: string,
	workflowData: any,
	isNoviUser: boolean = false,
): Promise<{ message: string; workflow: any }> => {
	const response = await apiClient.request({
		method: 'PATCH',
		endPoint: `${WORKFLOW_URL}/${clientId}/${workflowId}`,
		body: workflowData,
		clientType: isNoviUser ? 'NOVI' : 'RECEPTIONIST',
	});
	return response;
};

export const deleteWorkflow = async (
	clientId: string,
	workflowId: string,
	isNoviUser: boolean = false,
): Promise<{ message: string }> => {
	const response = await apiClient.request({
		method: 'DELETE',
		endPoint: `${WORKFLOW_URL}/${clientId}/${workflowId}`,
		clientType: isNoviUser ? 'NOVI' : 'RECEPTIONIST',
	});
	return response;
};
